import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ViewOrUpdateSF from '../../widgets/layout/ViewOrUpdateSF'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../widgets/layout/LRTableRowUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
//
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AccountNameViewUI from '../../components/accountSettings/accountName/AccountNameViewUI'
import AccountNameUpdateSF from '../../components/accountSettings/accountName/AccountNameUpdateSF'
import PrivatePageSF from '../../templates/PrivatePageSF'
import './AccountSettingsPage.css'

const AccSettingsFinPageUI = ({context, accountName, messageList, errorList, onNameUpdated}) =>
  <PrivatePageSF context={context} className='pg_acc_st_fin' backLink='/settings'
    centered={!accountName || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_account_settings'
  >
    {
      !accountName &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountName &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings' messageList={messageList} titleMessageKey='c_account_settings' />

        <LRTableBodyUI context={context}>

          <LRTableRowLinkUI
            context={context}
            to='/settings/account/customers'
            left={<label><MessageUI messageList={messageList} messageKey='c_customers' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

          <LRTableRowLinkUI
            context={context}
            to='/settings/account/product-items'
            left={<label><MessageUI messageList={messageList} messageKey='c_product_items' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

          {/*
            context.permissions.includes('acc_manage') &&
            <LRTableRowLinkUI
              context={context}
              to='/settings/account/cards'
              left={<label><MessageUI messageList={messageList} messageKey='c_payment_cards' /></label>}
              right={<div className="icon icon-caret-right"></div>}
            />
          */}

          {
            !context.permissions.includes('acc_manage') &&
            <LRTableRowUI context={context}
              left={<label><MessageUI messageList={messageList} messageKey='c_account_name' /></label>}
              right={<span>{accountName}</span>}
            />
          }

          {
            context.permissions.includes('acc_manage') &&
            <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_account_name'
              rightViewUI={<AccountNameViewUI context={context} messageList={messageList} accountName={accountName} />}
              updateUI={<AccountNameUpdateSF context={context} messageList={messageList} accountName={accountName} onUpdateComplete={onNameUpdated} />}
            />
          }
        </LRTableBodyUI>
      </div>
    }
  </PrivatePageSF>

export default AccSettingsFinPageUI
